import { useState, useCallback } from 'react';

/**
 * Hook for clipboard operations
 */
export const useClipboard = () => {
    const [copied, setCopied] = useState(false);

    /**
     * Copy text to clipboard
     * @param text - Text to copy
     * @returns Promise<boolean> - Success status
     */
    const copyToClipboard = useCallback(async (text: string): Promise<boolean> => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            
            // Reset copied state after 2 seconds
            setTimeout(() => {
                setCopied(false);
            }, 2000);
            
            return true;
        } catch (error) {
            console.error('Failed to copy to clipboard:', error);
            setCopied(false);
            return false;
        }
    }, []);

    return {
        copied,
        copyToClipboard
    };
};
